export default "__VITE_ASSET__DWMefx0t__"